import { render, staticRenderFns } from "./Vehicles.vue?vue&type=template&id=0afe4c88&scoped=true"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe4c88",
  null
  
)

export default component.exports